import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { initLoggingCapture } from 'army-builder-shared';
import 'hammerjs';

if (environment.production) {
    enableProdMode();
    initLoggingCapture(true);
} else {
    initLoggingCapture(false);
}

platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.log(err));
